import { DefaultState, DropdownItem } from 'store/types';

export const USERS_ACTIVITY_FILTERS_REQUEST = 'USERS_ACTIVITY_FILTERS_REQUEST';
export const USERS_ACTIVITY_FILTERS_SUCCESS = 'USERS_ACTIVITY_FILTERS_SUCCESS';
export const USERS_ACTIVITY_FILTERS_FAILURE = 'USERS_ACTIVITY_FILTERS_FAILURE';

export interface UsersActivityFiltersData {
  dates: Array<DropdownItem>;
  status: Array<DropdownItem>;
}

export type UsersActivityFiltersState = DefaultState & {
  contents?: UsersActivityFiltersData;
};

interface UsersActivityFiltersRequest {
  type: typeof USERS_ACTIVITY_FILTERS_REQUEST;
}

interface UsersActivityFiltersSuccess {
  type: typeof USERS_ACTIVITY_FILTERS_SUCCESS;
  contents: UsersActivityFiltersData;
}

interface UsersActivityFiltersFailure {
  type: typeof USERS_ACTIVITY_FILTERS_FAILURE;
}

export type UsersActivityFiltersActionTypes =
  | UsersActivityFiltersRequest
  | UsersActivityFiltersSuccess
  | UsersActivityFiltersFailure;
